document.documentElement.classList.remove('no-js');

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (!toggle) return;
  const menu = document.querySelector('[data-mobile-menu]');
  const open = toggle.getAttribute('aria-expanded') === 'true';
  toggle.setAttribute('aria-expanded', String(!open));
  menu.hidden = open;
});

document.addEventListener('change', (event) => {
  if (!event.target.matches('[data-variant-select]')) return;
  const form = event.target.closest('form');
  const price = form && form.querySelector('[data-product-price]');
  const option = event.target.selectedOptions[0];
  if (price && option.dataset.price) price.textContent = option.dataset.price;
});
